import React from 'react';
import { Facebook, Twitter, Instagram, Youtube, Lock, Mail, Phone } from 'lucide-react';

const TopBar = () => {
  return (
    <div className="hidden md:block bg-[#2C5F66] text-white text-sm">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        <div className="flex items-center gap-5">
          <a href="#" aria-label="facebook" className="hover:text-[#D9A04A] transition-colors"><Facebook size={16} /></a>
          <a href="#" aria-label="twitter" className="hover:text-[#D9A04A] transition-colors"><Twitter size={16} /></a>
          <a href="#" aria-label="instagram" className="hover:text-[#D9A04A] transition-colors"><Instagram size={16} /></a>
          <a href="#" aria-label="youtube" className="hover:text-[#D9A04A] transition-colors"><Youtube size={16} /></a>
          <a href="#" className="flex items-center gap-2 ml-3 hover:text-[#D9A04A] transition-colors">
            <Lock size={14} />
            <span className="font-medium">Client Portal Login</span>
          </a>
        </div>
        <div className="flex items-center gap-6">
          <a href="mailto:Info@WebsiteSymphony.com" className="flex items-center gap-2 hover:text-[#D9A04A] transition-colors">
            <Mail size={16} />
            <span>Info@WebsiteSymphony.com</span>
          </a>
          <span className="text-white/40">|</span>
          <a href="tel:+13058125999" className="flex items-center gap-2 hover:text-[#D9A04A] transition-colors">
            <Phone size={16} />
            <span>(305) 812-5999</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
